// extracted by mini-css-extract-plugin
export default {"labelsGroupContainer":"LabelsGroup_labelsGroupContainer__AAaiH","labelItemFixedWidth":"LabelsGroup_labelItemFixedWidth__rZdXg"};